export function parseDriverSelection(value, drivers = []) {
  if (value === "") return null;

  const driver = drivers.find(
    (item) => String(item.id) === String(value)
  );

  return driver ? Number(driver.id) : undefined;
}
